import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  open(event) {
    if (this.interactiveTarget(event.target)) return

    Turbo.visit(this.urlValue)
  }

  interactiveTarget(target) {
    return target.closest("a, button, input, select, textarea, summary, [data-clickable-row-ignore]")
  }
}
